import React, { useContext, useState } from "react";
import { setMixpanelProperties } from "../../../services/mixpanel/mixpanel";
import { attributionSource } from "../../../content/static/onboardingQuestions";

const OnboardingContext = React.createContext({
  onboardingAnswers: {}, // currently only used on /create-account for handling correct redirect link. Could do better and build pages using createPages
  addOnboardingAnswer: (answer: any) => {},
  updateOnboardingAnswer: (key: string, answer: any) => {},
  onboardingLandingPage: "",
  setOnboardingLandingPage: (value: string) => {},
  saveOnboardingDataToLocalStorage: () => {},
  customGroup: "",
  setCustomGroup: (value: string) => {},
});

export const useOnboardingContext = () => {
  const res = useContext(OnboardingContext);
  if (!res) {
    console.error("onboarding context is used outside of provider");
  }

  return res;
};

export const OnboardingProvider = ({ children }) => {
  const [onboardingAnswers, setOnboardingAnswers] = useState({});
  const [onboardingLandingPage, setOnboardingLandingPage] = useState(sessionStorage.getItem("landing_page") ?? "");
  const [customGroup, setCustomGroup] = useState("");

  const addOnboardingAnswer = (answer: any) => {
    setOnboardingAnswers(prev => ({
      ...prev,
      ...answer,
    }));
  };

  const updateOnboardingAnswer = (key: string, answer: any) => {
    if (key === attributionSource) {
      setMixpanelProperties({
        AttributionSource: answer,
      });
    }

    setOnboardingAnswers(prev => ({
      ...prev,
      [key]: answer,
    }));
  };

  const updateOnboardingLandingPage = (value: string) => {
    setOnboardingLandingPage(value);
    sessionStorage.setItem("landing_page", value);
  };

  const saveOnboardingDataToLocalStorage = () => {
    localStorage.setItem("onboardingAnswers", JSON.stringify(onboardingAnswers));
    localStorage.setItem("onboardingLandingPage", onboardingLandingPage);
  };

  const OnboardingValue = {
    onboardingAnswers,
    addOnboardingAnswer,
    updateOnboardingAnswer,
    onboardingLandingPage,
    setOnboardingLandingPage: updateOnboardingLandingPage,
    saveOnboardingDataToLocalStorage,
    customGroup,
    setCustomGroup,
  };

  return (
    <OnboardingContext.Provider value={OnboardingValue}>{children}</OnboardingContext.Provider>
  );
};
